// extracted by mini-css-extract-plugin
export default {"cardBoxSty":"UnitConsCompRate_cardBoxSty__afV3S","echarts_wrapper":"UnitConsCompRate_echarts_wrapper__AUNx7"};